import { WIKI_ATTACHMENT_MIME_TYPES } from "@/src/constants/files-extensions";
import { useWikiCreation } from "@/src/hooks/features/wiki/use-wiki-creation";
import ContentCreationForm from "@/src/utils/content-creation-form";
import { useTranslation } from "react-i18next";

export default function WikiCreationScreen() {
  const { t } = useTranslation();

  const {
    form,
    selectedCategoryIds,
    setSelectedCategoryIds,
    coverImage,
    setCoverImage,
    attachments,
    handleAddAttachments,
    handleRemoveAttachment,
    infoModal,
    confirmModal,
    handleCreate,
    handleSaveDraft,
    handleCancel,
    isSubmitting,
    setAttachmentError,
    attachmentError,
  } = useWikiCreation();

  return (
    <ContentCreationForm
      title={t("LABEL_ARTICLE_CREATION")}
      onBack={handleCancel}
      control={form.control}
      contentField="Content"
      attachmentHint={t("HINT_FILE_UPLOAD_TYPES_WIKI")}
      fields={[
        {
          name: "Title",
          label: t("HINT_ARTICLE_TITLE"),
          placeholder: t("HINT_ENTER_ARTICLE_TITLE"),
        },
        {
          name: "Content",
          label: t("HINT_ARTICLE_CONTENT"),
          placeholder: t("HINT_ENTER_ARTICLE_CONTENT"),
        },
      ]}
      categoryEntityType="wiki"
      selectedCategoryIds={selectedCategoryIds}
      onSelectedCategoryIdsChange={setSelectedCategoryIds}
      maxCategories={1}
      coverImage={coverImage}
      onCoverImageChange={setCoverImage}
      coverImageLabel={t("LABEL_ARTICLE_COVER_IMAGE")}
      attachments={attachments}
      onAddAttachments={handleAddAttachments}
      onRemoveAttachment={handleRemoveAttachment}
      showAttachments
      isLoading={isSubmitting}
      loadingText={t("LABEL_SAVING_ARTICLE")}
      loadingSubText={t("LABEL_PUBLISHING_PLEASE_WAIT")}
      acceptedAttachmentTypes={WIKI_ATTACHMENT_MIME_TYPES}
      secondaryAction={{
        label: t("BTN_CANCEL"),
        onPress: handleCancel,
        disabled: isSubmitting,
      }}
      primaryActions={[
        {
          label: t("BTN_CREATE_ARTICLE"),
          onPress: handleCreate,
          loading: isSubmitting,
        },
        {
          label: t("BTN_SAVE"),
          onPress: handleSaveDraft,
          loading: isSubmitting,
        },
      ]}
      infoModal={infoModal}
      confirmModal={confirmModal}
      attachmentAcceptedMimeTypes={WIKI_ATTACHMENT_MIME_TYPES}
      attachmentError={attachmentError}
      onAttachmentDropRejected={() =>
        setAttachmentError(t("ERROR_INVALID_WIKI_ATTACHMENT_TYPE"))
      }
    />
  );
}
